import { get } from "../../utils/objectHelpers";

$ {
    const filterLabel = get(input, 'sortItemsSelection.label.textSpans.[0].text', '');
    const title = get(input, 'title.textSpans.[0].text', '');
}

<if(filterLabel)>
    <div class="str-sort">
        <label><span>${filterLabel}:</span>
            <div>
                <ebay-menu-button text=state.selectedText reverse on-change("sortListings") type="radio">
                    <for|option| of=state.options>
                        <@item data-url=JSON.stringify(option.action.URL) checked=option.selected>
                            ${option.text}
                        </@item>
                    </for> 
                </ebay-menu-button>
                <if(title)>
                    <span class="clipped"> - ${title}</span>                
                </if>   
            </div>
        </label>
    </div>
</if>
